import { useBrand } from "@/providers/brand-provider";
import { cx } from "@/utils/cx";
import { BRAND_LABELS, type Brand } from "./index";
import centaurLogo from "./logos/centaur.svg";
import geminiLogo from "./logos/gemini.svg";
import orionLogo from "./logos/orion.svg";

const logos: Record<Brand, string> = {
    orion: orionLogo,
    gemini: geminiLogo,
    centaur: centaurLogo,
};

interface BrandLogoProps {
    /** Override the brand pulled from the BrandProvider context. */
    brand?: Brand;
    /** Extra classes merged onto the <img>. Defaults to `size-8`. */
    className?: string;
    /** Alt text override. Defaults to the brand label. */
    alt?: string;
}

/**
 * Renders the logo that matches the active brand. Reads from the nearest
 * BrandProvider unless `brand` is passed explicitly.
 */
export const BrandLogo = ({ brand, className, alt }: BrandLogoProps) => {
    const ctx = useBrand();
    const effective = brand ?? ctx.brand;

    return (
        <img
            src={logos[effective]}
            alt={alt ?? BRAND_LABELS[effective]}
            className={cx("size-8", className)}
        />
    );
};
